import styled, { useTheme } from 'styled-components';
import BrandBadge from 'components/BrandBadge';
import ClusterIcon from 'components/ClusterIcon';
import ClusterTooltip from 'components/ClusterTooltip';
import { PlaceholderText } from 'components/Placeholders';
import TikTokEmptyClusterIcon from 'components/TikTokEmptyClusterIcon';

const TikTokNameBodyColWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: ${({ $height }) => $height || '50px'};
    width: 100%;
    max-width: 100%;
    letter-spacing: 0;
`;

const HashtagList = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 18px;
    color: ${({ theme }) => theme.black};
    text-transform: lowercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    text-transform: none;
`;

const NameText = styled.span`
    text-transform: capitalize;
`;
const HashtagText = styled.span`
    text-transform: none;
    word-break: keep-all;
    ${({ $hashtagTextCss }) => $hashtagTextCss || ''}
`;

function Name({ isHashtagData, fetching, children, $hashtagTextCss }) {
    if (children && !isHashtagData) {
        return <NameText>{children}</NameText>;
    } else if (children) {
        return (
            <HashtagText $hashtagTextCss={$hashtagTextCss}>
                {children}
            </HashtagText>
        );
    } else if (fetching) {
        return '...';
    }
    return <>&mdash;</>;
}

const ClusterWrapper = styled.span`
    display: flex;
    align-items: center;
`;

const NameAndHashtagCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${({ theme }) => theme.gray_1};
    font-size: 16px;
    font-weight: 600;
`;

const TikTokNameBodyColInner = styled.div`
    display: flex;
    justify-content: space-between;
    min-width: 0;
    flex-grow: 1;
`;

const TableClusterIcon = styled(ClusterIcon)`
    font-size: 1.125rem;
`;

function TikTokNameBodyCol({
    row,
    isHashtagData,
    type,
    $hashtagTextCss = '',
    hideBrandBadge = true,
}) {
    const theme = useTheme();
    const $height = isHashtagData && type !== 'brands' ? '50px' : '75px';
    return (
        <TikTokNameBodyColWrapper $height={$height}>
            <TikTokNameBodyColInner>
                <NameAndHashtagCol>
                    {!isHashtagData ? (
                        <HashtagList>{row.hashtag_list}</HashtagList>
                    ) : type === 'brands' ? (
                        <div
                            css={`
                                color: ${theme.gray_2};
                                font-weight: 400;
                            `}
                        >
                            {hideBrandBadge ? (
                                <span>{row.brand_name}</span>
                            ) : (
                                <BrandBadge name={row.brand_name} />
                            )}
                        </div>
                    ) : null}
                    <Name
                        $hashtagTextCss={$hashtagTextCss}
                        fetching={row.fetching}
                        isHashtagData={isHashtagData}
                    >
                        {row.name}
                    </Name>
                </NameAndHashtagCol>
                <ClusterWrapper>
                    {row.cluster ? (
                        <ClusterTooltip
                            cluster={row.cluster}
                            dataSource="tiktok"
                        >
                            <TableClusterIcon cluster={row.cluster} />
                        </ClusterTooltip>
                    ) : row.fetchingData ? (
                        <PlaceholderText width="1.125rem" />
                    ) : (
                        <TikTokEmptyClusterIcon />
                    )}
                </ClusterWrapper>
            </TikTokNameBodyColInner>
        </TikTokNameBodyColWrapper>
    );
}

export default TikTokNameBodyCol;
